import styled from '@emotion/styled'
import { Box, Grid, Stack, Typography } from '@mui/material'

export const CampaignGraphsRoot = styled(Stack)(`
    width: 100%;
    // margin: 20px 0;
    padding: 10px;
    & .campaignMagnetScore {
        padding: 8px 0;
    }
    & .campaignMagnetScore p {
        font-size: 14px;
        line-height: 15px;
        margin-bottom: 10px;
    }
    &.subTrigger {
        & .tableHeadingRow:after { left: 290px; }
        & .graphWrapper {margin-left: 290px; width: calc(100% - 290px); padding:0; }
        & .graphWrapper .campaignMagnetScore { margin-left:0; padding:4px 0; }
        & .graphWrapper .campaignMagnetScore > p {
            left: -280px; max-width: 265px; 
            margin-bottom: 0;
            height: 35px;
            display: flex;
            align-items: center;
        }
        & table .headingTitle {
            width: 270px;
            min-width: 230px;
        }
    }

    &.triggerOuterWrapper {
        position: relative;
        // border: 1px solid blue;
        padding:30px 0 30px 300px;
        min-height:240px;
        border-bottom: 1px #D8D8D6 solid;
        margin-bottom: 10px;

        & .triggerInnerWrapper {
            display:flex;
            justify-content: space-between;
        }
        & .triggerInnerWrapper .graphWrapper {
            width:49%;
            padding: 0;
        }
        & .triggerInnerWrapper .NestedLevel2Wrap {
            display:none;
        }
        & .triggerInnerWrapper .graphWrapper .campaignMagnetScore {
            padding-left:0;
            padding-top: 20px;
            margin: 0;
            &>div{
                margin:5px 0;
            }
            &>p{
                left:0;
                top:-10px;
                width:fit-content;
                max-width:fit-content;
                top: 3px;
                font-weight:700;
                font-size: 13px;
            }
        }
    }
`)

export const CampaignMagnetScoreGraphWrapper = styled(Box)(`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 280px;
    height: 225px;
    position: absolute;
    top:10px;
    left:0;
    p {
        font-size: 13px;
        font-weight: 700;
        text-align: center;
        width: 100%;
    }
`)

export const TriggerInnerWrapper = styled(Box)(`
    &.triggerLastInnerWrapper {
    }
`)

export const CampaignBarWrap = styled(Box)(`
    display: flex;
`)

export const CampaignList = styled(Box)(`
    flex-direction: column;
    border-radius: 8px;
    min-height: 60px;
    border: 1px #E7E7E6 solid;
    padding: 15px;
    padding-left: 52px;
    position: relative;
    display: flex;
    margin-right: 20px;
    position: relative;
    & svg {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);

    }
`)

export const TableHeadingRow = styled(Typography)(`
    position: relative;
    height: 25px;

    &:before, &:after {
        content: 'Campaign';
        position: absolute;
        left: 8px;
        font-weight: 700;
        font-size: 13px;
    }
    &:after {
        content: 'Sentiment Split';
        left: 150px;
    }
`)

export const TitleForPPT = styled(Typography)(`
    font-size: 20px;
    font-weight: 400; // 300;
    line-height: 1.5;
    padding-bottom:20px;
    display:none;
`)

export const CardHeading = styled(Typography)(`
   font-size: 16px;
   font-weight: 600;
   margin-bottom: 20px;
`)

export const VerbatimWrap = styled(Box)(`
    background: #F5F5F5;
    padding: 20px;
    height: 100%;
`)

export const HeadingRow = styled(Box)(`
    display: flex;
    align-items: center;
    justify-content: space-between;
    & .headingRowTitle {
        font-size: 14px;
        font-weight: 400; // 300;
    };
    & .Information {
        font-size: 12px !important;
        font-weight: 400; // 300;
    }
`)

export const PageBreakerForPPT = styled(Box)(`
    display:none;
    height:3px; // BASED ON THIS HEIGHT THE PPT CODE WILL GIVE A PAGEBREAK
    width:100%;
    padding:0;
    margin:0;
    overflow:hidden;
`)
